import { BottomSheetState } from '@reducers/v2/bottomSheet/bottomSheet.slice';

export const popBottomSheetAction = (state: BottomSheetState) => {
	state.stack.pop();
	state.closeTargetId = null;
};
